  <p class=" float-right"><span data-dismiss="modal" aria-label="Close" class="cursor-pointer mr-2"><span aria-hidden="true">
        <img src="assets/themes/icons/cancel.svg" (click)="goBack()" alt="cancel" />
      </span></span></p>
  <div class="clearfix text-center mt-5 mb-5">
    <img src="assets/themes/icons/mrn-profile-success.svg" alt="verified" width="150px" height="150px" />

    <h5 class="mb-3 pt-3 heading-3">{{data?.message_title}}</h5>
    <p><span class="color-grey-700">{{data?.message_description}}</span></p>

    <p class="mt-5">
      <span (click)="assignAssociation()"
        class="btn-design medium filled">
        {{mls?.languageText?.verification_success_modal?.key1}}<span
          *ngIf="mls?.is_lskey_display == 1">(verification_success_modal.key1)</span>
      </span>
    </p>
  </div>